module.exports = __webpack_public_path__ + "img/right.7d8db889.png";